<script setup>
import { ref, watch } from 'vue';
import Switch from 'dashboard/components-next/switch/Switch.vue';

const props = defineProps({
  attribute: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['update']);

const attributeValue = ref(Boolean(props.attribute.value));

watch(
  () => props.attribute.value,
  value => {
    attributeValue.value = Boolean(value);
  }
);

const handleChange = value => emit('update', value);
</script>

<template>
  <div class="flex items-center h-8 gap-2">
    <Switch v-model="attributeValue" @change="handleChange" />
    <span class="text-sm truncate text-n-slate-11">
      {{ attribute.attributeDisplayName }}
    </span>
  </div>
</template>
